import {Component, ViewChild, OnInit, AfterViewInit, ElementRef, Input} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {ClientsService} from "../../../models/clients/clients.service";
import {IClientModel} from "../../../models/clients/clients.model";
import {ApplicationUser} from "../../../services/ApplicationUser";
import {FormGroup, FormBuilder, FormControl, FormArray} from "@angular/forms";
import {StaticDataService} from "../../../services/StaticData.service";
import {ClientVolumesService} from "../../../models/client-volumes/client-volumes.service";
import {ClientVolumesModel} from "../../../models/client-volumes/client-volumes.model";
import * as _ from "lodash";
import * as moment from "moment/moment";
import {ClientContactsModel} from "../../../models/client-contacts/client-contacts.model";
import {ClientContactsService} from "../../../models/client-contacts/client-contacts.service";
import {ClientContactsType} from "../../../models/client-contacts/client-contacts.type";
import {ClientProcessorsModel} from "../../../models/client-processors/client-processors.model";
import {ClientBanksModel} from "../../../models/client-banks/client-banks.model";
import {Observable} from 'rxjs/Observable';

declare var $: JQueryStatic | any;

import 'jquery-serializejson';
import 'jquery-validation';
import {handleResponseError} from "../../../app.helpers";
import {ClientOwnersService} from "../../../models/client-owners/client-owners.service";
import {ClientBanksService} from "../../../models/client-banks/client-banks.service";
import {ClientProcessorsService} from "../../../models/client-processors/client-processors.service";
import {ClientOwnersModel} from "../../../models/client-owners/client-owners.model";
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {OwnerInformationComponent} from "../../../modules/client-forms/owner-information/owner-information.component";
import {ContactsComponent} from "../../../modules/client-forms/contacts/contacts.component";
import {ErrorResponseModel} from "../../../models/response/response.model";
import {ValidationService} from "../../../services/validation.service";
import {NotesType} from "../../../models/notes/notes.type";
import {RoleTypes} from "../../../models/roles";
import {NotesComponent} from "../../../modules/notes/notes.component";
import {NotesModes} from "../../../modules/notes/notes.modes";
import {ProcessorsService} from '../../../models/processors/processors.service';
import {ProcessorsModel} from '../../../models/processors/processors.model';
import { MapsAPILoader, GoogleMapsAPIWrapper, AgmMarker } from '@agm/core';
import {MarkerImageModel, LabelModel} from "../../../models/pricings/marker-image.model";
import {PermissionsService} from "../../../services/permissions/permissions.service";
import {dateTimeHelper} from "../../../helpers/date";

import {phoneFormatter} from "../../../helpers/phone-format";

declare var google: any;


@Component({
    selector: 'client-info',
    templateUrl: 'client-info.template.html',
    styleUrls: ['client-info.css']
})
export class ClientInfoComponent implements OnInit, AfterViewInit {

    phoneFormatter = phoneFormatter;

    public moment = moment;

    @ViewChild(OwnerInformationComponent) ownerInformationComponent: OwnerInformationComponent;
    @ViewChild(ContactsComponent) contactsComponent: ContactsComponent;
    @ViewChild(NotesComponent) public notesComponent: NotesComponent;
    @ViewChild('confirmDialogDelete') public confirmDialogDelete;

    @ViewChild('leadCreateSchedule') public leadCreateSchedule;


    @Input()
    public clientId: number;


    public client: IClientModel = {
        mailing_location: new ClientLocationsModel(),
        business_location: new ClientLocationsModel(),
    };

    public clientVolumes: ClientVolumesModel[] = [];
    public clientProcessor = new ClientProcessorsModel();
    public clientBank = new ClientBanksModel();

    public industries: Array<any>;
    public businessLength: Array<any>;
    public timeFrame: Array<any>;
    public purpose: Array<any>;
    public fundingSpecialist: Array<any>;
    public editMode = false;

    public $businessForm: any;
    public $contactsForm: any;
    public $ownersForm: any;
    public $processorForm: any;
    public $bankForm: any;

    public notes;
    public customerNotes = '';
    public collectionNotes = '';

    public notesType = NotesType;

    public removeData: any;

    public userRole;
    public roleTypes = RoleTypes;
    public notesModes = NotesModes;

    public marker = <AgmMarker> {};
    public image = <MarkerImageModel> {};
    public zoom: number = 18;
    public label = <LabelModel> {};

    public processors = <ProcessorsModel[]> [];

    public loadingCount: any = 100000;

    constructor(private http: Http,
                private toasterService: ToasterService,
                private route: ActivatedRoute,
                private router: Router,
                public profile: ApplicationUser,
                public clientsService: ClientsService,
                public clientVolumesService: ClientVolumesService,
                public clientBanksService: ClientBanksService,
                public clientProcessorsService: ClientProcessorsService,
                public processorsService: ProcessorsService,
                protected validationService: ValidationService,
                protected el: ElementRef,
                public mapWrapper: GoogleMapsAPIWrapper,
                public permission: PermissionsService,
                public mapLoader: MapsAPILoader) {

        this.clientId = route.snapshot.parent.params['clientId'];
        this.businessLength = this.clientsService.getBusinessLength();
        this.timeFrame = this.clientsService.getTimeFrame();
        this.purpose = this.clientsService.getPurpose();
        this.industries = StaticDataService.getInstance().getData();

    }

    public isLoaded() {
        return this.loadingCount < 0.1 && this.ownerInformationComponent.isLoaded() && this.contactsComponent.isLoaded();
    }

    ngOnInit() {
        this.clientBank.client_id = this.clientId;
        this.clientProcessor.client_id = this.clientId;

        this.loadingCount = 6;

        this.clientProcessorsService.getOneByClient(this.clientId)
            .subscribe((res) => {
                this.clientProcessor = res.data;
                this.loadingCount--;
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
            });


        this.clientBanksService.getOneByClient(this.clientId)
            .subscribe((res) => {
                this.clientBank = res.data;
                this.loadingCount--;
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
            });

        this.clientVolumesService.getListByClient(this.clientId)
            .subscribe((res) => {
                this.clientVolumes = res.data;
                this.loadingCount--;
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
            });

        this.clientsService.getOne(this.clientId)
            .subscribe((res) => {
                this.client = res.data;
                this.client.mailing_location = this.client.mailing_location || new ClientLocationsModel();
                this.client.business_location = this.client.business_location || new ClientLocationsModel();
                this.loadingCount--;
                try {
                    this.getLocation("Canada "  + this.client.province.name +
                        " " +  (this.client.business_location.city || "") +
                        " " + (this.client.business_location.address_1 || ""));
                } catch (e) {
                    this.getLocation("Canada");
                }
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
                this.getLocation('Canada');
            });

        this.processorsService.getList()
            .subscribe((res) => {
                this.processors = res.data;
                this.loadingCount--;
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
            })

        this.clientsService.getInvitationStatus(this.clientId)
            .subscribe((res) => {
                this.setInvitationStatus(res.data);
                this.loadingCount--;
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
            });
    }

    ngAfterViewInit() {
        this.$businessForm = $('[name="business-form"]', this.el.nativeElement);
        this.$processorForm = $('[name="processor-form"]', this.el.nativeElement);
        this.$bankForm = $('[name="bank-form"]', this.el.nativeElement);

        this.validateForm();
    }

    // ===========================================================
    // Actions
    // ===========================================================


    public save() {

        if (!this.validate() || !this.ownerInformationComponent.validate() || !this.contactsComponent.validate()) {
            return;
        }

        this.$businessForm.submit();
        this.$processorForm.submit();
        this.$bankForm.submit();

        this.ownerInformationComponent.save();
        this.contactsComponent.save();
    }

    public toggleEditMode() {
        this.editMode = !this.editMode;
    }

    public cancelEditMode() {
        this.editMode = false;
    }

    public validate() {
        return this.$businessForm.valid() && this.$bankForm.valid() && this.$processorForm.valid();
    }

    public getProcessorName(id) {
        const processor = _.find(this.processors, {id: id});
        return processor ? processor.name : '';
    }
    public getLocation(address) {
        this.mapLoader.load().then(() => {

            this.createMarkerAttributes();

            let geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address }, (results, status) => {

                if (status === google.maps.GeocoderStatus.OK) {
                    this.marker.latitude = results[0].geometry.location.lat();
                    this.marker.longitude = results[0].geometry.location.lng();

                    if(!this.client.business_location.city) {
                        this.zoom = 5;
                    }

                    if(address == 'Canada') {
                        this.zoom = 3;
                    }
                } else {
                    console.error('Error - ', results, ' & Status - ', status);
                    this.marker.latitude = 56.130366;
                    this.marker.longitude = -106.34677099999999;
                    this.zoom = 3;
                }
            });
        });
    }

    public createMarkerAttributes() {
        this.label = {
            text: 'Address 1',
            color: "#000",
            fontWeight: 'bold'
        };
        this.image = {
            url: 'https://cdn1.iconfinder.com/data/icons/basic-app-set/24/map-pin-128.png',
            scaledSize: {height: 30, width: 30},
            labelOrigin: new google.maps.Point(17,40)
        };
    }





    // ===========================================================
    // Functions
    // ===========================================================


    private validateForm() {

        this.$businessForm
            .validate({
                submitHandler: (form) => {
                    this.clientsService.edit(this.clientId, this.client)
                        .subscribe(
                            (res) => {
                                this.client = res.data;
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.cancelEditMode();
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });

                }
            });


        this.$bankForm
            .validate({
                submitHandler: (form) => {
                    let observer = this.clientBank.id ? this.clientBanksService.edit(this.clientBank.id, this.clientBank) : this.clientBanksService.add(this.clientBank);

                    observer
                        .subscribe(
                            (res) => {
                                this.clientBank = res.data;
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });

                }
            });


        this.$processorForm
            .validate({
                submitHandler: (form) => {
                    let observer = this.clientProcessor.id ? this.clientProcessorsService.edit(this.clientProcessor.id, this.clientProcessor) : this.clientProcessorsService.add(this.clientProcessor);

                    observer
                        .subscribe(
                            (res) => {
                                this.clientProcessor = res.data;
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });

                }
            });

    }



    ////// DELETE CLIENT

    get canDeleteClient() {
        return this.client && this.client.id && this.permission.can('clients.delete');
    }

    deleteClient() {
        if (! this.canDeleteClient || this.deleteInProcess) return;
        //this.isDeleteConfirm = true;
        this.confirmDialogDelete.show('Do you want delete this client #' + this.client.id + '?');
    }

    public isDeleteConfirm = false;
    public deleteInProcess = false;

    hideDeleteConfirm() {
        if (this.deleteInProcess) return;
        this.isDeleteConfirm = false;
    }

    applyDeleteClient() {
        if (! this.canDeleteClient || this.deleteInProcess) return;
        this.deleteInProcess = true;
        this.clientsService.remove(this.clientId)
            .subscribe(
                (res) => {
                    //this.deleteInProcess = false;
                    //this.isDeleteConfirm = false;
                    this.toasterService.pop('success', 'Success', 'Deleted');

                    var route_snapshot = this.route.snapshot;
                    var urls = [];

                    while (route_snapshot) {
                        if (route_snapshot.url.length > 0.5) urls.push(route_snapshot.url[0].path);
                        route_snapshot = route_snapshot.parent;
                    }

                    if (urls.length < 0.5) this.router.navigate(['/']);
                    else if (urls.length < 1.5) this.router.navigate([urls[0]]);
                    else {
                        this.router.navigate([urls[urls.length - 1] + '/' + urls[urls.length - 2]]);
                    }
                },
                (error) => {
                    this.deleteInProcess = false;
                    this.isDeleteConfirm = false;
                    this.toasterService.pop('error', 'Error', 'Error deleting a client. Try again');
                }
            );
    }

    showCreateSchedule() {
        this.leadCreateSchedule.show({'id': this.clientId});
    }

    refreshNotes() {
        this.notesComponent.refresh();
    }

    sendInviteInProcess = false;

    get canSendInvite() {
        return this.client && this.client.id && this.client.email && this.permission.can('clients.delete');
    }

    get sendInviteName() {
        return 'Invite to client portal';
    }

    sendInvite() {
        if (! this.canSendInvite || this.sendInviteInProcess) return;

        this.sendInviteInProcess = true;
        this.clientsService.sendInvite(this.clientId)
            .subscribe(
                (res) => {
                    this.toasterService.pop('success', 'Success', 'Invitation has been sent');
                    this.sendInviteInProcess = false;

                    this.setInvitationStatus(res.data);
                },
                (error) => {
                    this.sendInviteInProcess = false;
                    let errorData = JSON.parse(error._body)
                    let errorTxt;
                    try {
                        errorTxt = errorData.errors[0];
                    } catch (e) {
                    }
                    if (! errorTxt) errorTxt = 'Error during sending invitation.';
                    this.toasterService.pop('error', 'Error', errorTxt);
                }
            );
    }

    invitationStatus: any = false;

    setInvitationStatus(status: any) {
        if (! status || ! status.msg) {
            this.invitationStatus = false;
            return;
        }

        var msg = status.msg;

        for (var i in status) {
            if (! status.hasOwnProperty(i) || i == 'msg') continue;

            if (i == 'date') status[i] = this.dateDisplayFormat(status[i]);

            msg = msg.replace('{' + i + '}', status[i]);
        }

        this.invitationStatus = msg;
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/client-forms/client-info/client-info.component.ts